import React from "react";
import { DatePicker } from "antd";

const { MonthPicker } = DatePicker;

function MonthSelector({ value, onChange, style, bordered = true }) {
  return (
    <MonthPicker
      value={value}
      onChange={(val) => val && onChange(val)}
      format="MMMM YYYY"
      style={{ width: 200, ...style }}
      allowClear={false}
      bordered={bordered}
    />
  );
}

export default MonthSelector;